import React, {Component} from 'react';

import {Row, Col} from "@amzn/stencil-react-components/layout";
import {H3} from "@amzn/stencil-react-components/text";
import {MOCK_ID, MOCK_ID as TEST_ID} from "../../../../utils/testConstants";

class TilesArea extends Component {

  render() {
    const {title} = this.props;

    return (
      <Col margin={{left: 10}}>
        <Col dataTestId={MOCK_ID.TILE_AREA_TITLE} margin={{bottom: 20}}>
          <H3 fontWeight="medium" fontSize="T200">{title}</H3>
        </Col>
        <Row
          flexWrap="wrap"
          gridGap={20}
          margin={{bottom: 20}}
        >
          {this.props.children}
        </Row>
      </Col>
    )
  }
}

export default TilesArea
